var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_7660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51172 17.0039C8.71485 16.9883 9.76953 16.6055 10.6758 15.8555C11.582 15.1055 12.1523 14.1602 12.3867 13.0195L12.4102 12.9961H14.4961V14.9883H16.5117V12.9961H18.5039V15.9961H20.4961V12.9961H21.5039V11.0039H12.4102C12.1602 9.84765 11.582 8.89063 10.6758 8.13281C9.76953 7.375 8.71485 6.99609 7.51172 6.99609C6.82422 6.99609 6.17578 7.1289 5.56641 7.39453C4.95703 7.64453 4.42578 7.99609 3.97266 8.44922C3.51953 8.90235 3.16016 9.43359 2.89453 10.043C2.6289 10.6523 2.49609 11.3008 2.49609 11.9883C2.49609 12.6758 2.6289 13.3242 2.89453 13.9336C3.16016 14.543 3.51953 15.0742 3.97266 15.5273C4.42578 15.9805 4.95703 16.3398 5.56641 16.6055C6.17578 16.8711 6.82422 17.0039 7.51172 17.0039ZM7.51172 8.98828C8.33985 8.98828 9.04687 9.28125 9.63281 9.86719C10.2188 10.4531 10.5117 11.1602 10.5117 11.9883C10.5117 12.8164 10.2188 13.5234 9.63281 14.1094C9.04687 14.6953 8.33985 14.9883 7.51172 14.9883C6.68359 14.9883 5.97657 14.6953 5.39062 14.1094C4.80468 13.5234 4.51172 12.8164 4.51172 11.9883C4.51172 11.1602 4.80468 10.4531 5.39062 9.86719C5.97657 9.28125 6.68359 8.98828 7.51172 8.98828Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_7660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0078,
    height: 10.0078,
    fill: "white",
    transform: "translate(2.49609 6.99609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/1765983986/media/icon-key.117e0ed770bd9a5fad98c47cad097b55.svg";
export { ForwardRef as ReactComponent };